// @vendors
import React from "react";
import PropTypes from "prop-types";

// @components
const WizardError = require("components/commons/wizardError/wizardError");

// @utilities
const { FormattedText } = require("core/i18n").i18n;

class ModalContent extends React.PureComponent {
    render() {
        const { hasError } = this.props;
        return (
            <div className="aggregator-add-entity-modal">
                {!hasError ? (
                    <div className="aggregator-add-entity-modal__content">
                        <div className="aggregator-add-entity-modal__content__terms">
                            <FormattedText value="aggregatorAddEntityModal-termsContent" />
                        </div>
                    </div>
                ) : (
                    <WizardError
                        errorMessage={
                            <FormattedText value="aggregatorAddEntityModal-errorTitle" />
                        }
                    >
                        <FormattedText value="aggregatorAddEntityModal-errorDescription" />
                    </WizardError>
                )}
            </div>
        );
    }
}

ModalContent.propTypes = {
    hasError: PropTypes.bool,
};

export default ModalContent;
